import React, { useState } from 'react';
import { ClickElement, InputField } from '../form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './DateNavigator.css';
import { MENU } from '../../lib/labels';


export const SingleDayNavigator = ({ onSubmit }) => {

  const maxDays = 365;
  const [daysBack, setDaysBack] = useState('');
  const [error, setError] = useState({ showError: false, message: '' });

  const submit = e => {
    e.preventDefault();
    setError({ ...error, showError: false });
    onSubmit(daysBack);
  };

  return (
    <div className={styles.calendar}>
      <form 
        onSubmit={submit}
        className="form"
      >
        <div className={styles.field}>
          <InputField
            type='text'
            placeholder={MENU.SINGLE_DAY_NAVIGATOR.PLACEHOLDER}
            value={daysBack}
            name='daysback'
            onChange={e => {
              if (Number(e.target.value) || e.target.value === '0' || e.target.value === '') {
                setError({});
                if (e.target.value <= maxDays) {
                  setDaysBack(e.target.value);
                } else {
                  setError({ showError: true, message: MENU.SINGLE_DAY_NAVIGATOR.ERROR_MESSAGES.MAX_DATE(maxDays) });
                }
              } else {
                setError({ showError: true, message: MENU.SINGLE_DAY_NAVIGATOR.ERROR_MESSAGES.ONLY_NUMBERS });
              }
            }}
            autoComplete="off"
            required
          />
          <ClickElement
            primary
            ElementType='button'
            type='submit'
            text={MENU.SINGLE_DAY_NAVIGATOR.BUTTON_TEXT}
          />          
        </div> 
        {error.showError && <p className={styles['error-block']}>{error.message}</p>}
        <div className={styles['info-block']}>
          <div className={styles.icon}> 
            <FontAwesomeIcon icon={['fas', 'info-circle']} size="2x" />
          </div>
          <span>{MENU.SINGLE_DAY_NAVIGATOR.INFO_TEXT}</span>
        </div> 
        <hr className={styles.divider} />
      </form>
    </div>
  );
};